import { all } from "redux-saga/effects";
import { saga as aceitarTermoAceite } from "./actions/aceitarTermoAceite";
import { saga as obterTermoAceiteAtivo } from "./actions/obterTermoAceiteAtivo";

export default all([obterTermoAceiteAtivo, aceitarTermoAceite]);
